import type {ValueType} from '@github-ui/custom-properties-types'
import {ActionList, ActionMenu, FormControl} from '@primer/react'
import {clsx} from 'clsx'
import {useState} from 'react'

import {PROPERTY_TYPE_DROPDOWN_BUTTON_ID} from '../../helpers/definition-form-validators'
import {definitionTypeLabels, getDefinitionLabel} from '../../helpers/definition-type-label'

interface Props {
  value: ValueType
  readonly: boolean
  onChange: (type: ValueType) => void
  className?: string
}

export function DefinitionTypeSelector({value, readonly, onChange, className}: Props) {
  const [isOpen, setIsOpen] = useState(false)
  const selectedDefinitionTypeLabel = getDefinitionLabel(value)

  return (
    <FormControl className={clsx('mb-3', className)} disabled={readonly}>
      <FormControl.Label>Type</FormControl.Label>
      <ActionMenu
        open={isOpen}
        onOpenChange={open => {
          if (readonly) return
          setIsOpen(open)
        }}
      >
        <ActionMenu.Button
          id={PROPERTY_TYPE_DROPDOWN_BUTTON_ID}
          inactive={readonly}
          aria-disabled={readonly}
          aria-label={`Type: ${selectedDefinitionTypeLabel}`}
        >
          {selectedDefinitionTypeLabel}
        </ActionMenu.Button>
        <ActionMenu.Overlay>
          <ActionList selectionVariant="single">
            {Object.entries(definitionTypeLabels).map(([key, label]) => (
              <ActionList.Item key={key} onSelect={() => onChange(key as ValueType)} selected={value === key}>
                {label}
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </FormControl>
  )
}

try{ DefinitionTypeSelector.displayName ||= 'DefinitionTypeSelector' } catch {}